import { SLACK_CLIENT_ID } from 'config';

import React, { Component } from 'react';

import { VERIFY_SIGN_IN_WITH_SLACK_URL } from '../../constants';
import createQuery from '../../utils/createQuery';

import signInWithSlackImage from './signInWithSlack.svg';

export default class SignInWithSlackButton extends Component {
  render() {
    const params = {
      scope: 'identity.basic,identity.team,identity.avatar',
      client_id: SLACK_CLIENT_ID,
      redirect_uri: VERIFY_SIGN_IN_WITH_SLACK_URL,
    };

    const query = createQuery(params);

    const signInWithSlackURL = `https://slack.com/oauth/authorize?${query}`;
    return (
      <a href={signInWithSlackURL}>
        <img
          alt="Sign in with Slack"
          height="40px"
          src={signInWithSlackImage}
        />
      </a>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/SignInWithSlackButton/index.jsx
 **/